// extracted by mini-css-extract-plugin
export default {"formulario":"Contato_formulario__VeO50","btnEnviar":"Contato_btnEnviar__b1H8p"};